import { render, staticRenderFns } from "./MesaNew.vue?vue&type=template&id=230eb459&scoped=true"
import script from "./MesaNew.vue?vue&type=script&lang=js"
export * from "./MesaNew.vue?vue&type=script&lang=js"
import style0 from "./MesaNew.vue?vue&type=style&index=0&id=230eb459&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230eb459",
  null
  
)

export default component.exports